 
import PropertyBreadcrumb from "../../commonComponents/breadcrumbs/PropertyBreadcrumb";
import SortBy from "../../commonComponents/SortBy";
import GridView from "../../commonComponents/gridView";

const PropertyWithoutSliderContainer = () => {
  return (
    <>
      <PropertyBreadcrumb />
      <SortBy />
      <GridView type="property" sectionClass="property-inner-section property-list" gridType="list-view" gridSize={1} view="image" />
    </>
  );
};

export default PropertyWithoutSliderContainer;
